import axios from "axios";
import store from "../store";

axios.defaults.withCredentials = false;
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;

JSON.parse(localStorage.getItem("token"))
  ? store.commit("setToken", JSON.parse(localStorage.getItem("token")))
  : null;
JSON.parse(localStorage.getItem("userInfo"))
  ? store.commit("setUser", JSON.parse(localStorage.getItem("userInfo")))
  : null;
// set locker from local storage to state
JSON.parse(localStorage.getItem("locker_info"))
  ? store.commit("setLocker", JSON.parse(localStorage.getItem("userInfo")))
  : null;
// set layout from local storage to state
JSON.parse(localStorage.getItem("premiumLayout"))
  ? store.commit(
      "changePremiumLayoutState",
      JSON.parse(localStorage.getItem("premiumLayout"))
    )
  : null;
let token = store.getters.StateUser.token;

store.subscribe((mutation, state) => {
  if (mutation.type === "setToken") {
    token = state.Auth.user.token || "";
  }
});

axios.interceptors.request.use(
  (config) => {
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
